import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { XenaClient } from 'src/app/services';
import { IDanishCompanyIndex } from 'src/app/xena-api/dtos';
import {  IQueryStringFilter, defaultQueryStringFilter } from 'src/app/xena-api/filters';
import {  Page } from 'src/app/xena-api/response-types';

@Injectable({
  providedIn: 'root'
})
export class ExternalService {

  constructor(private xenaClient: XenaClient) { }

  getDanishCompanyByCVRList(filter: IQueryStringFilter = defaultQueryStringFilter): Observable<Page<IDanishCompanyIndex>> {
    const path: string = '/ExternalData/DanishCompanyByCVR';
    return this.xenaClient.list<IDanishCompanyIndex, IQueryStringFilter>(path, filter);
  }
}
